const createGestorFilter = options => ({
  id: 'Gestor',
  type: 'searchSelect',
  label: 'Gestor',
  placeholder: 'Selecione o gestor',
  options
});

const createCidadeFilter = options => ({
  id: 'Cidade',
  type: 'searchSelect',
  label: 'Cidade',
  placeholder: 'Selecione a cidade',
  options
});

export const getFilterConfigMotorista = (gestorOptions = [], cidadeOptions = []) => [
  {
    id: 'NomeMotorista',
    type: 'text',
    label: 'Nome do Motorista',
    placeholder: 'Digite o nome do motorista'
  },
  createCidadeFilter(cidadeOptions),
  createGestorFilter(gestorOptions),
  {
    id: 'Cpf',
    type: 'text',
    label: 'CPF',
    placeholder: 'Digite o CPF'
  },
  {
    id: 'Disponivel',
    type: 'searchSelect',
    label: 'Status',
    placeholder: 'Selecione...',
    options: [
      {
        value: 'true',
        label: 'Disponivel'
      },
      {
        value: 'false',
        label: 'Indisponivel'
      }
    ]
  }
];
